import type {
  ModuleEnum,
  PermissionOperationEnum,
  UserGroupModulePermissionResponse,
} from 'src/api/ProactApiClient';
import {useAppSelector} from 'src/redux/hooks';
import {usePermissions} from './usePermissions';

export interface useHasModulePermissionProps {
  module?: ModuleEnum;
  operation?: PermissionOperationEnum;
  operationName?: string;
}
export const useHasModulePermission = ({
  module,
  operation,
  operationName,
}: useHasModulePermissionProps): {
  hasPermission: boolean;
} => {
  const {isSuperAdmin} = useAppSelector(state => state.session);
  const {permissions} = usePermissions();

  const permission = findModulePermission(
    permissions,
    module,
    operation,
    operationName
  );
  const hasPermission = permission !== undefined;

  // Super admins bypass all module permission checks, matching the backend
  // ProactAuthorize attribute which authorizes super admins for every module.
  if (isSuperAdmin) {
    return {hasPermission: true};
  }

  return {hasPermission};
};

export const findModulePermission = (
  permissions: UserGroupModulePermissionResponse[],
  module?: ModuleEnum,
  operation?: PermissionOperationEnum,
  operationName?: string
) => {
  return permissions?.find(
    i =>
      i.module === module &&
      i.operation === operation &&
      (i.operationName === operationName ||
        (!i.operationName && !operationName))
  );
};
